import 'css-chunk:src/components/callout-alert/callout-alert-component.module.scss';export default {
  "callout-alert-component": "callout-alert-component_callout-alert-component__9-INv",
  "pink": "callout-alert-component_pink__TBCvI",
  "icon": "callout-alert-component_icon__ij6nX",
  "yellow": "callout-alert-component_yellow__vFgo8",
  "green": "callout-alert-component_green__97QSM",
  "teal": "callout-alert-component_teal__DG8aE",
  "purple": "callout-alert-component_purple__L5dHp",
  "title": "callout-alert-component_title__Z24ZB",
  "headline": "callout-alert-component_headline__cmsJV"
};